import { DecimalPipe } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateService } from 'apps/di-ld/src/app/app-state.service';
import { pathUrl } from 'apps/di-ld/src/app/configs';
import {
  GA_CUSTOM_DIMENSION,
  GA_EVENT_ACTION,
  GA_EVENT_CATEGORY,
  PAYMENT_TYPE_TERM,
} from 'apps/di-ld/src/app/core/constant/base.enum';
import { IPendingDocuments } from 'apps/di-ld/src/app/core/interfaces';
import {
  FirebaseParam,
  EventGATagging,
} from 'apps/di-ld/src/app/core/interfaces/js-interface.interface';
import {
  ApplicationsService,
  JsInterfaceService,
  PendingDocumentsService,
} from 'apps/di-ld/src/app/core/services';
import { HeaderControlService } from 'apps/di-ld/src/app/core/services/header/HeaderControlService';
import dayjs from 'dayjs';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'web-di-ld-status-consider',
  templateUrl: './status-consider.component.html',
  styleUrls: ['./status-consider.component.scss'],
})
export class StatusConsiderComponent implements OnInit {
  options: AnimationOptions = {
    path: '/assets/animation/pending-icon/pending-icon.json',
  };
  @Input() selectedData!: any;
  @Input() getCurrentLang?: string;
  @Input() applicationRef!: string;

  public paymentTermEnum = PAYMENT_TYPE_TERM;
  readonly decimalPipe = new DecimalPipe(this._locale);
  pendingDocumentsList?: IPendingDocuments;
  documentCount: number = 0;
  isCollapse?: boolean;
  showMoreFlag = false;
  showMoreFlagDocumentNotRequired = false;
  documentCountRequired: number = 0;
  documentCountNotRequired: number = 0;
  isResubmitedDocument = false;

  constructor(
    @Inject(LOCALE_ID) public _locale: string,
    private jsInterfaceService: JsInterfaceService,
    private appState: AppStateService,
    private pendingDocumentsService: PendingDocumentsService,
    private router: Router,
    private applicationsService: ApplicationsService,
    private headerControlService: HeaderControlService
  ) {}

  ngOnInit(): void {
    if (this.selectedData?.application.status === 'FOU_COMPLETE2') {
      this.isResubmitedDocument = true;
    }

    setTimeout(() => {
      this.headerControlService.setShowHeader(false);
    });
    this.applicationsService.setGaTaggingBasedOnStatus(
      GA_EVENT_CATEGORY.PENDING_APPROVE
    );
    const event = {
      action: GA_EVENT_ACTION.VIEW,
      category: GA_EVENT_CATEGORY.PENDING_APPROVE,
      label: '',
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    this.gaTagging(event, dimension);
    this.getDocList();
  }

  ngOnDestroy() {
    this.headerControlService.setShowHeader(true); // คืน header เมื่อออกจากหน้า
  }

  async getDocList() {
    if (!this.applicationRef) {
      this.applicationRef = this.appState.applicationRef;
    }
    this.pendingDocumentsList = await this.pendingDocumentsService.getDocList(
      this.applicationRef
    );
    this.documentCountRequired =
      this.pendingDocumentsList?.documentType?.filter((doc) => doc.doc_require)
        ?.length || 0;
    this.documentCountNotRequired =
      this.pendingDocumentsList?.documentType?.filter((doc) => !doc.doc_require)
        ?.length || 0;
  }

  toggleDocList() {
    this.isCollapse = !this.isCollapse;
  }

  arriveDate(date?: string) {
    const dateArrive = dayjs(date);
    const dateNow = dayjs();
    const arriveDate = dateArrive.diff(dateNow, 'day');
    return arriveDate + 1;
  }

  parseToDecimal(value: any) {
    return this.decimalPipe.transform(value, '1.2-2');
  }

  gaTagging(event: EventGATagging, dimension?: FirebaseParam[]) {
    this.jsInterfaceService.gaTagging(event, dimension);
  }

  back() {
    this.router.navigate([pathUrl.appInprogress]);
  }

  goToHome() {
    const event = {
      action: GA_EVENT_ACTION.CLICK,
      category: GA_EVENT_CATEGORY.PENDING_APPROVE,
      label: GA_EVENT_CATEGORY.PENDING_APPROVE + '_Confirm',
      value: '',
    };
    const dimension = [
      {
        key: GA_CUSTOM_DIMENSION.KEY,
        value: this.selectedData.application.productType,
      },
    ];
    this.gaTagging(event, dimension);

    this.router.navigateByUrl('/');
  }

  showMore() {
    this.showMoreFlag = !this.showMoreFlag;
  }

  showMoreDocumentNotRequired() {
    this.showMoreFlagDocumentNotRequired = !this
      .showMoreFlagDocumentNotRequired;
  }
}
